document.addEventListener('DOMContentLoaded', function() {
  
  // ====================================================================
  // 1. XỬ LÝ VIDEO Ở PHẦN MÔ TẢ / PAGE BUILDER (Bằng cảm biến trượt)
  // ====================================================================
  const videoObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.play().catch(() => {});
      } else {
        entry.target.pause();
      }
    });
  }, { threshold: 0.5 });

  document.querySelectorAll('video[autoplay]').forEach(video => {
    videoObserver.observe(video);
  });


  // ====================================================================
  // 2. XỬ LÝ VIDEO Ở KHUNG ẢNH CHÍNH (Giám sát trạng thái is-active)
  // ====================================================================
  const mediaItems = document.querySelectorAll('.product__media-item');
  
  const activeObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      // Bắt sóng ngay khi theme Dawn thay đổi class của ảnh/video
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const target = mutation.target;
        
        // TRƯỜNG HỢP A: Video vừa được trượt tới (hiển thị)
        if (target.classList.contains('is-active')) {
          
          // Mở video HTML5
          const video = target.querySelector('video');
          if (video) video.play().catch(() => {});
          
          // Mở video YouTube/Vimeo
          const iframe = target.querySelector('iframe');
          if (iframe) iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
          
          // Kích hoạt video nếu còn đang kẹt ở ảnh bìa
          const deferredMedia = target.querySelector('deferred-media');
          if (deferredMedia && !deferredMedia.hasAttribute('loaded')) {
            const posterBtn = deferredMedia.querySelector('.deferred-media__poster');
            if (posterBtn) posterBtn.click();
          }

        } 
        // TRƯỜNG HỢP B: Video bị trượt qua (ẩn đi)
        else {
          const video = target.querySelector('video');
          if (video) video.pause();
          
          const iframe = target.querySelector('iframe');
          if (iframe) iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        }
      }
    });
  });

  // Gắn "camera giám sát" vào tất cả các slide trong khung ảnh chính
  mediaItems.forEach(item => {
    activeObserver.observe(item, { attributes: true });
  });

});